module.exports = __webpack_public_path__ + "static/media/Belgium.290e02d7.jpg";